export const OPERATION_ICON = {
  pedido: 'icon-enterprise',
  ofrecido: 'icon-employee'
};
  